<template>
  <div class="open-button">
    <wx-button
      v-if="isWeixinPlatform"
      :androidAPKUrl="androidAPKUrl"
      :buttonStyle="buttonStyle"
      :buttonTxt="buttonTxt"
      :type="type"
      :point="point"
      :itemNo="itemNo"
      :subKdtId="subKdtId"
      :itemId="itemId"
    />
    <h5-button
      v-else
      v-on="$listeners"
      :androidAPKUrl="androidAPKUrl"
      :buttonStyle="buttonStyle"
      :buttonTxt="buttonTxt"
      :type="type"
      :point="point"
      :itemNo="itemNo"
      :subKdtId="subKdtId"
      :itemId="itemId"
    />
  </div>
</template>

<script>
import { isWeixin, isAndroid } from '../../utils'
import wxButton from '../../components/wxButton'
import h5Button from '../../components/h5Button'

import { checkUpdate } from '../../api'


export default {
  name: 'OpenButton',
  props: {
    buttonStyle: {
      type: String,
      default: '',
    },
    buttonTxt: {
      type: String,
    },
    itemNo: [String, Number],
    subKdtId: [String, Number],
    itemId: [String, Number],
    type: {
      type: String,
      default: 'default',
    },
    point: {
      type: String,
      default: '',
    },
  },
  data(){
    return {
      isWeixinPlatform: false,
      androidAPKUrl: null,
    }
  },

  mounted(){
    this.isWeixinPlatform = isWeixin()
    console.log(isWeixin())
    isAndroid() && this.checkUpdateRequest()
  },
  methods:{
    checkUpdateRequest(){
      const params = {
        appChannel: 902,
        currentVersion: 0
      }
      checkUpdate(params).then(res => {
        console.log('res---', res)
        if (res.code === 200) {
          this.androidAPKUrl = res.data.address
          // this.androidAPKUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.cotticoffee.cotticlient'
        }
      })
      // const params = {
      //   appChannel: 402,
      //   currentVersion: 1
      // }
      // checkUpdate(params).then(res => {
      //   if (res.code === 200) {
      //     if(res.busCode === '1'){
      //        this.androidAPKUrl = res.data.address
      //     }else{
      //       this.$toast({ message: res.busMessage});
      //     }
      //   } else {
      //     this.$toast({ message: res.message});
      //   }
      // })
    }
  },
  components:{
    wxButton,
    h5Button
  },
}
</script>

